import styled from 'styled-components';

import { OpenNewTabIcon, SupportInfoIcon } from '@genially/icons';

import { SmallParagraph } from '../../../foundations/typefaces/SmallParagraph';
import style from '../../../style';

export const StyledSupportInfoIcon = styled(SupportInfoIcon)(
  ({ theme: { size, transition } }) => ({
    width: size.units(2),
    minWidth: size.units(2),
    height: size.units(2),
    minHeight: size.units(2),
    transition: transition.standard('color'),
  }),
);

export const StyledOpenNewTabIcon = styled(OpenNewTabIcon)(
  ({ theme: { size, transition } }) => ({
    width: size.units(2),
    minWidth: size.units(2),
    height: size.units(2),
    minHeight: size.units(2),
    transition: transition.standard('color'),
  }),
);

export const StyledSmallParagraph = styled(SmallParagraph)(
  ({ theme: { transition } }) => ({
    transition: transition.standard('color'),
    textDecoration: 'underline',
  }),
);

export const Wrapper = styled.div<{ $reversed: boolean }>(
  ({ theme: { size, color }, $reversed }) => ({
    display: 'flex',
    alignItems: 'flex-start',
    cursor: 'pointer',

    [StyledSmallParagraph]: {
      marginLeft: size.units(1),
      marginRight: size.units(1),
    },

    [`${StyledSmallParagraph}, ${StyledSupportInfoIcon}, ${StyledOpenNewTabIcon}`]: {
      color: $reversed
        ? color.content.reversed.default()
        : color.content.primary.default(),
    },

    ...style.mixins.devices.desktop({
      '&:hover': {
        [`${StyledSmallParagraph}, ${StyledSupportInfoIcon}, ${StyledOpenNewTabIcon}`]: {
          color: $reversed
            ? color.content.reversed.hover()
            : color.content.primary.hover(),
        },
      },
    }),
  }),
);
